export default {"src":"/_next/static/media/checkbox-image-light.617de67e.svg","height":100,"width":100};